import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ListingSellingPlatform')
export class ListingSellingPlatform {
  @JsonProperty('sellingPlatform', String, true) sellingPlatform: string = undefined;
  @JsonProperty('country', String, true) country: string = undefined;
}
